const styleAttrRegex = /(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi;

export const removeStyleAttributeFromHTMLString = (string) => string.replace(styleAttrRegex, '');